var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterWhiteMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6H0.5V0H6.5V2H2.5V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.06 5.02L17.1667 5C17.3533 5 17.5 5.14667 17.5 5.33333V15.4133C17.5 15.5667 17.4 15.6867 17.26 15.7333L13.5 17L9.5 15.6L5.94 16.98L5.83333 17C5.64667 17 5.5 16.8533 5.5 16.6667V6.58667C5.5 6.43333 5.6 6.31333 5.74 6.26667L9.5 5L13.5 6.4L17.06 5.02ZM15.5 14.2145L13.5124 14.884L13.5 14.8797V8.51762L13.5353 8.52998L15.5 7.76839V14.2145ZM12.5 8.16762L10.5 7.46762V13.8297L12.5 14.5297V8.16762ZM9.5 7.11762V13.4797L9.46469 13.4673L7.5 14.2289V7.78286L9.48759 7.11328L9.5 7.11762Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16H0.5V22H6.5V20H2.5V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20V22H22.5V16H20.5V20H16.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2V0H22.5V6H20.5V2H16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterWhiteMapIcon);
export default __webpack_public_path__ + "static/media/centerWhiteMapIcon.42134f9a31d880730a6c1291982e9c48.svg";
export { ForwardRef as ReactComponent };